import { Component, Output, EventEmitter, ElementRef} from '@angular/core';
import {ApiServiceModule} from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  constructor(
    private elRef:ElementRef,
    private apiService: ApiServiceModule,
    private formBuilder: FormBuilder,
    private helper: HelperModule,
    private sharedService: SharedService,
    ) {}
  @Output() createAccountEvent = new EventEmitter<any>();
  @Output() connexionEvent = new EventEmitter<any>();
  mailPhoneControl = new FormControl();
  passwordControl = new FormControl();
  message = '';
  isStudent = false;
  userType = 'user'
  ngOnInit(){
  }
  authenticate(){
    if (this.mailPhoneControl.value != null && this.passwordControl.value != null) {
      const data = {
        mail_phone: this.mailPhoneControl.value,
        password: this.passwordControl.value,
        user_type: this.userType
      };
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/user_login', data, '').subscribe((response:any)=>{
        //this.helper.showToast(response.message);
        if(response.status){
          //this.sharedService.sendData({user_infos: response.user_infos});
          this.connexionEvent.emit(response.user_infos)
        }else this.helper.showToast(response.message);
      }) 
    }else this.helper.showToast("Email ..");
    
  }
  toggleUserStudent(){
    this.isStudent = !this.isStudent;
    this.userType = this.isStudent ? 'student': 'user';
  }
  registration(){
    this.createAccountEvent.emit();
  }
}
